import { CfetLabelsConstant } from '../constants/cfet-labels.constant';
import { CfetMessagesConstant } from '../constants/cfet-messages.constant';
import { CfetButtonLabelsConstant } from '../constants/cfet-button-labels.constant';
import { CfetTitlesConstant } from '../constants/cfet-titles.constant';
import { CfetNavLablesConstant } from '../constants/cfet-nav-lables.constant';
import { CfetNavLinksConstant } from '../constants/cfet-nav-links.constant';

export abstract class CfetBaseComponent {
    cfetLabels: any;
    cfetMessages: any;
    cfetButtonLabels: any;
    cfetTitles: any;
    cfetNavLables: any;
    cfetNavLinks: any;
    constructor() {
        this.cfetLabels = CfetLabelsConstant.CFET_ICAM_LABELS;
        this.cfetMessages = CfetMessagesConstant.CFET_MESSAGES;
        this.cfetButtonLabels = CfetButtonLabelsConstant.CFET_BUTTON_LABELS;
        this.cfetTitles = CfetTitlesConstant.CFET_TITLES;
        this.cfetNavLables = CfetNavLablesConstant.CFETNAVLABLES;
        this.cfetNavLinks = CfetNavLinksConstant.CFETNAVLINKS;
    }
}
